import * as React from 'react';
import { useCallback, useState } from 'react';
import { Area } from 'react-easy-crop';
import { DialogContent, DialogTitle, Typography } from '@mui/material';
import { getCroppedImg } from '../../../utils/cropImage';
import { CropImage } from '../../cropImage/CropImage';
import { DialogActionButtons } from '../../dialogActionButtons/DialogActionButtons';
import { BootstrapDialog, dialogStyles, useStyles } from './modalUpload.styles';
import { ICrop, IProps } from './types';

export const ModalUpload = (props: IProps): JSX.Element => {
  const initSize = { width: 0, height: 0, x: 0, y: 0 };
  const [croppedImagePixels, setCroppedImagePixels] = useState<ICrop>(initSize);
  const [rotation, setRotation] = useState<number>(0);
  const classes = useStyles();
  const { open, setOpen, image, setCroppedImage, savePhoto } = props;

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleSave = async(): Promise<void> => {
    const croppedOne = await getCroppedImg(image, croppedImagePixels, savePhoto, rotation);
    setCroppedImage(croppedOne || '');
    setOpen(false);
    setRotation(0);
  };

  const onCropComplete = useCallback((croppedArea: Area, croppedAreaPixels: Area) => {
    setCroppedImagePixels(croppedAreaPixels);
  }, []);

  const actionProps = {
    cancel: 'CANCEL',
    submit: 'SAVE',
    handleClose,
    handleSubmit: handleSave,
  };

  return (
    <div>
      <BootstrapDialog
        className={classes.modal}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={dialogStyles}
          className={classes.modalMainTitle}
        >
          Edit photo
        </DialogTitle>
        <DialogContent>
          <Typography
            gutterBottom
            className={classes.modalTitle}
          >
            The selected area will be displayed on your page.
            If the image is not oriented correctly, the photo can be rotated.
          </Typography>
          <div>
            {image
              ? <div className={classes.image}>
                <CropImage
                  image={image}
                  rotation={rotation}
                  setRotation={setRotation}
                  onCropComplete={onCropComplete}
                />
              </div>
              : <div className={classes.imageError} />}
          </div>
        </DialogContent>
        <DialogActionButtons {...actionProps} />
      </BootstrapDialog>
    </div>
  );
};
